import _ from 'lodash';
import { toggleIsLoading } from './loading'
import messageActions from './message'
import modalActions from './modal';
import locationConstants from '../constants/location';
import locationService from '../services/location';
import tokenHelpers from '../helpers/token';
import refreshHelpers from '../helpers/Refresh';

const locationList = (data) => ({ type: locationConstants.LIST_LOCATION, data })
const locationRetrieve = (detail) => ({ type: locationConstants.RETRIEVE_LOCATION, detail })
const locationCreate = (detail) => ({ type: locationConstants.CREATE_LOCATION, detail })
const locationUpdate = (detail) => ({ type: locationConstants.UPDATE_LOCATION, detail })
const locationSelect = (selected) => ({ type: locationConstants.SELECT_LOCATION, selected })
const locationSelectAll = (toggle) => ({ type: locationConstants.SELECT_ALL_LOCATION, toggle })
const locationClear = () => ({ type: locationConstants.CLEAR_LOCATION })
const multiLocationSelect = (id, value) => ({
  type: locationConstants.MULTISELECT_LOCATION,
  id,
  value
})

const locationActions = {}

locationActions.setLocationError = (errorMessage) => ({
  type: locationConstants.SET_LOCATION_ERROR,
  error: errorMessage
});

locationActions.clearLocationError = () => ({
  type: locationConstants.CLEAR_LOCATION_ERROR
});

locationActions.list = (vendorKey, path=false) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    locationService.list(vendorKey)
    .then((response) => {
      dispatch(locationList(response));
      dispatch(toggleIsLoading(false));
      let selectedToken = tokenHelpers.getLocationToken();
      if (selectedToken) {
        let index = 0;
        for (let loc of response) {
          if (loc.apikey === selectedToken) {
            dispatch(locationActions.selectLocation(loc, path))
            dispatch(locationActions.multiSelectLocation(index, true))
            break;
          }
          index+=1;
        }
        return;
      }

      if(response.length) {
        dispatch(locationActions.selectLocation(response[0], path))
        dispatch(locationActions.multiSelectLocation(0, true))
      }
      
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

locationActions.retrieve = (vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    locationService.retrieve(vendorApiKey, locationApiKey)
    .then((response) => {
      dispatch(locationRetrieve(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

locationActions.create = (body, vendorApiKey) => {
  return async (dispatch) => {
    dispatch(toggleIsLoading(true));
    
    locationService.create(body, vendorApiKey)
    .then((response) => {
      dispatch(locationCreate(response));
      dispatch(locationActions.list(vendorApiKey));
      dispatch(modalActions.modalToggle(false));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(locationActions.setLocationError(err.message));
    })
  }
}

locationActions.update = (body, vendorApiKey, locationApiKey) => {
  return async (dispatch) => {
    dispatch(toggleIsLoading(true));

    locationService.update(body, vendorApiKey, locationApiKey)
    .then((response) => {
      dispatch(locationUpdate(response));
      dispatch(locationActions.list(vendorApiKey));
      dispatch(modalActions.modalToggle(false));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(locationActions.setLocationError(err.message));
    })
  }
}

locationActions.selectLocation = (location, path=false) => {
  return (dispatch, getState) => {
    dispatch(locationSelect(location));
    localStorage.setItem('location_api_key', location.apikey)
    if (path)
      refreshHelpers.refetchPath(
        dispatch, path,
        getState().vendor.selected.apikey,
        location.apikey);
  }
}

locationActions.clearSelectedLocation = (path=false) => {
  return (dispatch, getState) => {
    dispatch(locationClear());
    localStorage.removeItem('location_api_key')
    if (path)
      refreshHelpers.refetchPath(
        dispatch, path,
        getState().vendor.selected.apikey,
        '');
  }
}

locationActions.multiSelectLocation = (id, value) => {
  return (dispatch) => {
    dispatch(multiLocationSelect(id, value));
  }
}

locationActions.selectAllLocation = (toggle) => {
  return (dispatch) => {
    dispatch(locationSelectAll(toggle));
  }
}


export default locationActions;



/** WEBPACK FOOTER **
 ** ./src/actions/location.js
 **/